import * as React from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { SocialMediaStepType, descriptors } from "./descriptors";
import { RouteComponentProps, withRouter } from "react-router";
import { Header, Form } from "semantic-ui-react";
import "./styles.scss";
import { FloatedCard } from "../../containers";
import { TacSection } from "../TacSection";

interface OwnProps {
  handleSubmit?: () => void;
  handleBack?: () => void;
  messages?: { info?: string[]; error?: string[]; warn?: string[] };
  isSubmitting?: boolean;
  step: number;
}

type Props = OwnProps & RouteComponentProps;

/**
 * Represents a SignUp screen.
 */
const SocialNetworkFC: React.FC<Props> = ({ messages, handleBack, handleSubmit, isSubmitting, step }) => {
  const { formatMessage } = useIntl();
  const [tacAccepted, setTacAccepted] = React.useState<boolean>(false);

  const content = (
    <React.Fragment>
      <div className={"socialContainer"}>
        <TacSection handleTacChange={setTacAccepted} dataElmId={"registerSocialContainer"} />
      </div>

      <Header as="h5" textAlign="center">
        {step} of 2
      </Header>

      <Form.Group widths="equal" className={"buttonContainer"}>
        <Form.Button
          size="large"
          data-elm-id={"registerSocialButtonBack"}
          type="submit"
          color={"grey"}
          disabled={isSubmitting}
          onClick={handleBack}
          className={"secondary"}
        >
          <FormattedMessage {...descriptors[SocialMediaStepType.back]} />
        </Form.Button>

        <Form.Button
          size="large"
          type="submit"
          data-elm-id={"registerSocialButtonSubmit"}
          disabled={isSubmitting || !tacAccepted}
          onClick={handleSubmit}
          className={"signUp"}
        >
          <FormattedMessage {...descriptors[SocialMediaStepType.submit]} />
        </Form.Button>
      </Form.Group>
    </React.Fragment>
  );

  return (
    <FloatedCard
      title={formatMessage({ ...descriptors[SocialMediaStepType.title] })}
      subtitle={formatMessage({ ...descriptors[SocialMediaStepType.subtitle] })}
      content={content}
      messages={messages}
      isSubmitting={isSubmitting}
      size={"bigCentered"}
    />
  );
};

export const SocialMediaStep = withRouter(SocialNetworkFC);
